/**
 * The delivery line under a message the user sent (mission stream contract
 * phase 4, agion/Agion#2327): sending, queued, delivered, or why it failed or
 * was refused and where it went. The texts are deliveryTexts.ts and, for the
 * typed reason of a refused receipt (phase 6), receiptReasonTexts.ts.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { deliveryLine, type DeliveryTone } from './deliveryTexts'
import type { AnswerOrigin, MessageDelivery } from '../../hooks/useAnswerDelivery'

const TONE_CLASS: Record<DeliveryTone, string> = {
  progress: 'text-slate-500 dark:text-slate-400',
  done: 'text-slate-500 dark:text-slate-400',
  problem: 'text-red-700 dark:text-red-400',
}

export interface DeliveryStatusProps {
  delivery: MessageDelivery
  /** Where a returned send went: the message box, or the question's choices. */
  origin?: AnswerOrigin
}

export const DeliveryStatus: React.FC<DeliveryStatusProps> = ({ delivery, origin }) => {
  const { t } = useTranslation(['chat'])
  const { tone, line } = deliveryLine(t, delivery, origin)
  return (
    <p
      className={`text-xs mt-1 ${TONE_CLASS[tone]}`}
      role={tone === 'problem' ? 'alert' : 'status'}
      data-testid="delivery-status"
      data-state={delivery.state}
    >
      {line}
    </p>
  )
}
